import { useState } from "react";
import { customEvent } from "goi_common";

export interface RegionFaq {
  question: string;
  answer: string;
}

interface RegionFAQProps {
  sigunguName: string;
  faqs: RegionFaq[];
}

export const RegionFAQ = ({ sigunguName, faqs }: RegionFAQProps) => {
  const [openIndex, setOpenIndex] = useState(0);

  if (!faqs.length) return null;

  return (
    <section className="rg-section" id="faq" aria-labelledby="rg-faq-title">
      <h2 id="rg-faq-title" className="rg-section__title">
        {`${sigunguName} 장례식장 자주 묻는 질문`}
      </h2>

      <ul className="rg-faq">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <li key={faq.question} className="rg-faq__item">
              <button
                type="button"
                className="rg-faq__q"
                aria-expanded={isOpen}
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "prlr_region",
                      trigger_and_target: `faq_open_${index + 1}`,
                    },
                  });
                  setOpenIndex(isOpen ? -1 : index);
                }}
              >
                <span>{faq.question}</span>
                <span className="rg-faq__mark" aria-hidden="true">
                  {isOpen ? "−" : "+"}
                </span>
              </button>

              {isOpen && <p className="rg-faq__a">{faq.answer}</p>}
            </li>
          );
        })}
      </ul>
    </section>
  );
};
